'use client';
import type { Faqs as FaqsType } from '@/types';

import React from 'react';
import parse from 'html-react-parser';
import { useSearchParams } from 'next/navigation';

import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Container,
  Image,
  Text,
} from '@/components';
import { useTranslation } from '@/hooks';
import NoResult from '@/images/header/noResult.png';
import { fonts } from '@/theme';

const Faqs: React.FC<{ faqs: FaqsType[] }> = ({ faqs }) => {
  const [expandedItem, setExpandedItem] = React.useState<number | number[]>();

  const searchParams = useSearchParams();

  React.useEffect(() => {
    setExpandedItem(-1);
  }, [searchParams]);

  const { t } = useTranslation('pages.faq');
  return (
    <Container>
      {faqs.length > 0 ? (
        <Accordion
          allowToggle
          index={expandedItem}
          onChange={(expandedIndex) => setExpandedItem(expandedIndex)}
        >
          {faqs?.map((item) => (
            <AccordionItem
              id={item.id}
              key={item.id}
              backgroundColor="gray.250"
              borderTop="0"
              borderRadius="md"
              my="18px"
              px="22px"
              py="10px"
              _last={{ borderBottom: '0' }}
            >
              {({ isExpanded }) => (
                <>
                  <AccordionButton
                    px={0}
                    _hover={{
                      backgroundColor: 'gray.250',
                    }}
                  >
                    <Text
                      flex="1"
                      textAlign="right"
                      fontSize="md"
                      color="text"
                      fontWeight="bold"
                    >
                      {item.question}
                    </Text>
                    <AccordionIcon
                      color={isExpanded ? 'primary.500' : 'text'}
                      width={{ base: '1.5rem', md: '2rem' }}
                      height={{ base: '1.5rem', md: '2rem' }}
                    />
                  </AccordionButton>
                  <AccordionPanel
                    px={0}
                    sx={{
                      '*': {
                        fontFamily: `${fonts.style.fontFamily} !important`,
                        fontSize: '16px !important',
                        lineHeight: '',
                      },
                    }}
                  >
                    {parse(item.answer)}
                  </AccordionPanel>
                </>
              )}
            </AccordionItem>
          ))}
        </Accordion>
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent={'center'}
          alignItems="center"
          mb="100px"
        >
          <Image src={NoResult} alt="noResult" width="195" height="113.5" />
          <Text fontSize="md" paddingBlock="16px" textAlign="center">
            {t('hasNotResponse')}
          </Text>
        </Box>
      )}
    </Container>
  );
};
export default Faqs;
